<template>
    <div>
        <Private-header></Private-header>
        <div class="container" :style="{'min-height': height+'px'}">
            <div class="user-info">
                <img v-if="user.head_path" :src="user.head_path | img_url_finish" class="avatar">
                <img v-else :src="$store.state.static_img_url+'/img/default-head-img.png'" class="avatar">
                <p class="name">{{user.name}}</p>
            </div>
            <div class="options">
                <div v-for="item in options" :key="item.url" class="option-item" @click="goPage(item.r_name, item.query)">
                    <span>{{item.name}}</span>
                    <i class="iconfont">&#xe705;</i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrivateHeader from '../../components/Headers/header2'

export default {
    components:{
        "PrivateHeader": PrivateHeader
    },
    computed:{
        user() {
            return this.$store.state.user
        },
    },
    data(){
        return {
            height: 0,
            options:[
                { name:'基本资料', r_name:'SetUserInfo', query: {edit: 1} },
                { name:'我的收藏', r_name:'Collect' },
                { name:'上传论文', r_name:'ThesisList' },
                { name:'报名列表', r_name:'SignUp' },
                { name:'申请发票', r_name:'InvoiceList' },
                { name:'申请学分', r_name:'PointList' }
            ]
        }
    },
    methods:{
      goPage(r_name, query){
        this.$router.push({name: r_name, query: query})
      }
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
.container
    padding: 0 .32rem
    background: #F8F8F8
    padding-top: .88rem
    .user-info
        height: 4.1rem
        display: flex
        flex-direction: column
        justify-content:center
        align-items: center
        .avatar
            width: 2rem
            height: 2rem
            border-radius: 50%
            border: 1px solid #E12222
        .name
            font-size: .32rem
            font-weight:bold
            color:rgba(51,51,51,1)
            margin-top: .31rem
    .options
        margin-top: .6rem
        background: #ffffff
        border-radius: .1rem
        .option-item
            padding: 0 .35rem
            font-size: .28rem
            font-weight:bold
            color: #333333
            height: 1.06rem
            line-height: 1.06rem
            i
                font-size: .12rem
                float:right
        .option-item + .option-item
            border-top: 1px solid #EEEEEE
</style>
